export class HideFilter {

	constructor(selector,options = {}) {

		this.parent = typeof selector === 'string'
		? document.querySelector(selector)
		: selector;

		if (!this.parent) return;

		const defaultOptions = {

			triggersClass: '.ToggleSectionTriggers',
			triggerClass: '.ToggleSectionTrigger',
			targetsClass: '.ToggleSectionTargets',
			targetClass: '.ToggleSectionTarget',
			dataAttr: 'data-toggle-section-id',
		}

		this.allTriggers = {};
		this.allTargets = {};

		this.options = Object.assign(defaultOptions, options);

		this._onClick = this._onClick.bind(this);

		this._setup();

	}

	_setup() {

		const triggers = this.parent.querySelectorAll(
			`${this.options.triggersClass} ${this.options.triggerClass}`
		);
		const targets = this.parent.querySelectorAll(
			`${this.options.targetsClass} ${this.options.targetClass}`
		);

		this.allTriggers = triggers;
		this.allTargets = targets;

		triggers.forEach(trigger => {

			trigger.addEventListener("click", this._onClick);

		});

	}
	
	_onClick( event ) {

		const trigger = event.currentTarget;

		const triggerId = trigger.getAttribute(this.options.dataAttr);

		const triggerMatch = Array.from(this.allTriggers).some(item => item.getAttribute(this.options.dataAttr) === triggerId);
		const targetMatch = Array.from(this.allTargets).some(item => item.getAttribute(this.options.dataAttr) === triggerId);

		if (triggerMatch && targetMatch) {

			this._updateActiveClass( this.allTriggers, this.options.dataAttr, triggerId);
			this._updateActiveClass( this.allTargets, this.options.dataAttr, triggerId);

		}

	}

	_updateActiveClass( items,attrLabel,match ) {

		items.forEach(item => {
			if (item.getAttribute(attrLabel) === match) {
				item.classList.toggle('hide');
			}
		});

	}

	reset() {

		if(this.allTriggers.length && this.allTargets.length ) {

			this.allTriggers.forEach( el => {

				el.classList.remove('hide');

			} );

			this.allTargets.forEach( el => {

				el.classList.remove('hide');

			} );

		}

	}

}